// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { AddCompanyComponent } from 'src/app/modules/companies/pages/add-company/add-company.page';
import { CompaniesListComponent } from 'src/app/modules/companies/pages/companies-list/companies-list.page';
import { CompanyDetailComponent } from 'src/app/modules/companies/pages/company-detail/company-detail.page';
import { PhonebookComponent } from 'src/app/modules/companies/pages/phonebook/phonebook.page';
import { ViewCompanyComponent } from 'src/app/modules/companies/pages/view-company/view-company.page';
import { CompaniesSuspendedListComponent } from './pages/companies-suspended-list/companies-suspended-list.page';
import { CompaniesInformativeNoteListComponent } from './pages/companies-informative-note-list/companies-informative-note-list.page';

const routes: Routes = [
  {
    path: 'list',
    component: CompaniesListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadCompaniesList']
    },
  },
  {
    path: 'detail/:companyId',
    component: CompanyDetailComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canCreateCompanies']
    },
  },
  {
    path: 'my-company',
    component: ViewCompanyComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canViewCompany']
    },
  },
  {
    path: 'add',
    component: AddCompanyComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canCreateCompanies']
    },
  },
  {
    path: 'my-phonebook',
    component: PhonebookComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canViewPhonebook']
    },
  },
  {
    path: "suspended",
    component: CompaniesSuspendedListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ["canReadCompaniesList"]
    }
  },
  {
    path: "informative-note",
    component: CompaniesInformativeNoteListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ["canReadCompaniesList"]
    }
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class CompaniesRoutingModule { }
